import React, { Component } from 'react';
import { Button, FormControl, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import './AssignCourse.css';
import infoIcon from '../../resources/img/info-icon.png';

class AssignCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCourse: null,
      selectedDate: new Date(),
      courses: this.props.coursesInHub,
      deadlineEnabled: false
    };
  }
  render() {
    const { saveCourse } = this.props;
    return (
      <div className="assign-course-modal-container">
        <div>
          <div className="text-container">
            <p>Assign New Course</p>
          </div>
          <div className="dropdown-containers">
            <FormGroup className="form" controlId="formCategory">
              <div className="label-1"> Course:
                <div className="info-container">
                <img
                  className="info-icon"
                  src={infoIcon}
                  alt="help icon"
                  style={{ height: '18px', width: '18px', marginTop:'5px' }}
                />
                <span
                  className="hover-text"
                  style={{ top: '-5px', left: '0px' }}
                >
                  Courses can be created under the Create tab in your Hub. 
                  Select "eLearning Course" to begin creating your Course. 
                  You can assign your Course to Groups within the Course settings page too.
                </span>
              </div>
              </div>
              
              <FormControl
                className="course-select"
                componentClass="select"
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedCourse = this.state.courses.find(
                    (course) => course.id === parseInt(selectedId, 10)
                  );
                  this.setState({ selectedCourse });
                }}
              >
                {' '}
                {/*  Need to add code for removing the courses available in the create page,  get the courses from createCourse*/}
                <option value="select">Select Course</option>
                {this.state.courses.map((course) => (
                  <option key={course.id} value={course.id} disabled={course.isDraft}>
                    {course.title}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup
              className="form form-group"
              style={{
                opacity: !this.state.deadlineEnabled ? 1 : 0.3,
                pointerEvents: !this.state.deadlineEnabled ? 'auto' : 'none',
                transition: 'opacity 0.3s ease-in-out'
              }}
            >
              <ControlLabel>Set Deadline:</ControlLabel>
              <DatePicker
                value={this.state.selectedDate}
                onChange={(date) => {
                  this.setState({ selectedDate: date });
                }}
                clearIcon={null}
                calendarIcon={
                  <i
                    className="fa fa-calendar fa-2x"
                    style={{ color: '#14B4C8' }}
                  />
                }
              />
            </FormGroup>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginRight: '200px'
              }}
            >
              <Checkbox
                className="checkbox"
                name="commentGroup"
                onChange={() =>
                  this.setState({
                    deadlineEnabled: !this.state.deadlineEnabled
                  })
                }
                checked={this.state.deadlineEnabled}
              >
                No Deadline
              </Checkbox>
              <div className="info-container" style={{ marginTop: '5px' }}>
                <img
                  className="info-icon"
                  src={infoIcon}
                  alt="help icon"
                  style={{ height: '18px', width: '18px' }}
                />
                <span
                  className="hover-text"
                  style={{ top: '-5px', left: '0px' }}
                >
                  If no deadline is selected, a default date five years from
                  today will be automatically applied.
                </span>
              </div>
            </div>
          </div>
          <div className="button-container">
            <Button
              className="save-button"
              onClick={() => {
                let date = this.state.deadlineEnabled
                  ? new Date().setFullYear(new Date().getFullYear() + 5)
                  : this.state.selectedDate;
                saveCourse(this.state.selectedCourse, date);
              }}
            >
              save
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
//AssignCourse
export default AssignCourse;
